module.exports = __webpack_public_path__ + "img/porto.687ad61d.png";